module.exports = __webpack_public_path__ + "static/OffGrid2-e51ed9b572e32f58b5f69e71fb628888.png";